module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "cont"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('strong', [_c('em', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/intro#int"
    }
  }, [_vm._v("Introduction by Donna Leon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/prac#pra"
    }
  }, [_vm._v("Practical Guideline")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch1"
    }
  }, [_vm._v("WALK 1 : Meeting Brunetti")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WALK 2 : Rialto and the Senses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WALK 3 : Brunetti’s Neighbourhood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WALK 4 : Food and Faliers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WALK 5: Weather and Houses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WALK 6: Expatriate Venice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WALK 7: Rich and Poor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WALK 8: Piazza San Marco")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WALK 9: Questura World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WALK 10: Remote Venice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WALK 11: Artful Properties")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WALK 12: The Most Beautiful Neighbourhood in the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/back01#back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brunetti’s Lagoon Islands")])]), _vm._v(" "), _c('p', {
    staticClass: "bgh"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0